import { RefinementCtx, ZodIssueCode, object, string } from "zod";

export const financeDealWidgetSchema = (
    minDepositAmountValue: number,
    maxDepositAmountValue: number
) =>
    object({
        deposit: string().transform((value: string, ctx: RefinementCtx): string => {
            if (!value && typeof value !== "number") {
                ctx.addIssue({
                    code: ZodIssueCode.custom,
                    message: "Please enter a deposit",
                });
            }

            const parsedValue = parseInt(value.replaceAll(",", ""));

            if (isNaN(parsedValue)) {
                ctx.addIssue({
                    code: ZodIssueCode.custom,
                    message: "Please enter a deposit",
                });
            } else if (parsedValue < minDepositAmountValue) {
                ctx.addIssue({
                    code: ZodIssueCode.custom,
                    message: `Please enter a deposit amount above £${minDepositAmountValue}`,
                });
            } else if (parsedValue > maxDepositAmountValue) {
                ctx.addIssue({
                    code: ZodIssueCode.custom,
                    message: "Please enter a lower deposit amount",
                });
            }

            return parsedValue.toString();
        }),
    });
